import React from 'react';
import { Plane, Map, ArrowRight, Clock } from 'lucide-react';

const areas = [
  'Whitefield', 'Koramangala', 'Indiranagar', 'HSR Layout', 'Electronic City', 'Marathahalli',
  'Sarjapur Road', 'Bellandur', 'Hebbal', 'Yelahanka', 'Jayanagar', 'JP Nagar', 'BTM Layout',
  'Banashankari', 'Rajajinagar', 'Malleshwaram', 'Hennur', 'KR Puram', 'Mahadevapura', 'Devanahalli',
];

const pillars = [
  {
    icon: Plane,
    title: 'Airport Taxi Bangalore',
    text: 'On-time pickups and drops to Kempegowda International Airport (KIA) from anywhere in Bengaluru. Sedan from ₹1350, SUV from ₹1850 — all inclusive, 24/7, flight-tracked.',
  },
  {
    icon: Map,
    title: 'Outstation Cabs from Bangalore',
    text: 'Round-trip and one-way outstation taxis at ₹14/km (Sedan) and ₹18/km (SUV) to Mysuru, Coorg, Ooty, Wayanad, Tirupati, Hampi, Chikmagalur and across Karnataka & South India.',
  },
  {
    icon: ArrowRight,
    title: 'One Way Cabs – Fixed Fare',
    text: 'Pay only for one way: Bangalore to Hyderabad, Chennai, Mysuru, Coimbatore, Tirupati and Goa at flat fares with tolls, permit, fuel and driver allowance included — and the same price on the return leg.',
  },
  {
    icon: Clock,
    title: 'Hourly Cab Rental',
    text: 'Local hourly packages from ₹375/hr for meetings, shopping, hospital visits, weddings and Bangalore Darshini city tours, with a dedicated chauffeur who waits for you.',
  },
];

export const SeoContent = () => (
  <section id="service-areas" data-testid="seo-content" className="py-20 bg-[#000000] border-t border-white/5">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mb-12">
        <span className="inline-flex items-center px-4 py-2 rounded-full bg-[#d4af37]/10 border border-[#d4af37]/30 text-[#d4af37] text-xs font-semibold uppercase tracking-[0.2em] mb-4">
          Taxi Near You in Bengaluru
        </span>
        <h2 className="font-display text-3xl sm:text-4xl font-semibold text-white mb-4 tracking-tight">
          Taxi Service in Bangalore for Airport, Outstation &amp; One Way Trips
        </h2>
        <p className="text-gray-400 leading-relaxed">
          Searching for a <strong className="text-gray-200">cab near me</strong> in Bangalore? SG Cabs is a locally
          owned taxi service with professional chauffeurs, clean Sedans (Dzire, Etios) and SUVs (Ertiga, Innova),
          transparent fares and no hidden charges. Book online, call{' '}
          <a href="tel:+917507867648" className="text-[#d4af37] hover:underline">+91 75078 67648</a> or WhatsApp us
          — day or night.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-14">
        {pillars.map(({ icon: Icon, title, text }) => (
          <article key={title} className="lux-card rounded-2xl p-6 flex gap-4">
            <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-[#d4af37]/10 border border-[#d4af37]/30 flex items-center justify-center">
              <Icon className="w-5 h-5 text-[#d4af37]" aria-hidden="true" />
            </div>
            <div>
              <h3 className="font-display text-lg font-semibold text-white mb-2">{title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{text}</p>
            </div>
          </article>
        ))}
      </div>

      <div>
        <h3 className="text-sm font-semibold text-[#d4af37] uppercase tracking-[0.15em] mb-4">
          Areas we serve in Bengaluru
        </h3>
        <ul data-testid="service-areas-list" className="flex flex-wrap gap-2">
          {areas.map((area) => (
            <li key={area} className="px-3 py-1.5 rounded-full bg-[#121212] border border-white/10 text-gray-300 text-sm">
              Taxi in {area}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);
